import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

// PrimeNG
// eslint-disable-next-line sort-imports
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-demo-tag',
    templateUrl: './demo-tag.component.html',
    styleUrls: ['./demo-tag.component.scss'],
    imports: [ButtonModule, CommonModule, DialogModule, TagModule, TooltipModule],
})
export class DemoTagComponent {
    public isVisibleDemoDialog = false;
}
